import React, {
  useEffect,
  useState,
  useRef,
} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  useHistory,
  // Redirect,
  useParams,
  // useLocation,
  Switch,

} from 'react-router-dom';

import { getStore } from '../firebase/store';
import { useBookingEvents } from '../hooks/useBookingEvents';

export default function Book() {
  const history = useHistory();
  const isMounted = useRef(false);
  let params = useParams();
  const storeId = useRef(params.storeId);

  const [eventId, setEventId] = useState("");
  const [store, setStore] = useState();
  const events = useBookingEvents(storeId.current);

  useEffect(() => {
    isMounted.current = true;
    init();
    return (
      () => {
        isMounted.current = false;
      }
    );
  }, []);

  useEffect(() => {
    if (typeof params.eventId !== 'undefined') {
      setEventId(params.eventId);
    } else {
      Object.keys(events).length > 0
        && setEventId(Object.keys(events)[0]);
    }
  }, [params, events]);

  const init = async () => {
    const store = await getStore(storeId.current);
    isMounted.current && setStore(store);
  };

  const handleEventChange = (e) => {
    history.push("/butiker/" + storeId.current + "/boka-tid/" + e.target.value);
  };

  const handleViewUsers = (storeId, date, time) => {
    history.push("/butiker/" + storeId + "/boka-tid/" + date + "/tid/" + time)
  }
  const classes = useStyles();

  return (
    <Route
      render={() =>
        <div style={{ textAlign: "left" }}>

          <Typography
            component="h4"
            variant="h5"
            color="primary"
            style={{ textAlign: "left", marginBottom: 0 }}
          >
            Tider
          </Typography>
          <Typography
            component="h2"
            variant="body1"
            color="primary"
            style={{ textAlign: "left", marginBottom: 30 }}
          >
            {store?.name}
          </Typography>

          <Select
            labelId="select-event"
            id="select-event"
            value={eventId}
            onChange={handleEventChange}
            label="Event"
            variant='filled'
          >
            {
              Object.keys(events).map((key) => {
                const event = events[key];
                return (
                  <MenuItem
                    value={event.id}
                    key={event.id}
                  >{event.dateString}</MenuItem>
                );
              })
            }
          </Select>
          <br />

          <Paper className={classes.paper}>
            <div
              style={{ width: "100%" }}
              className={classes.root}
            >
              <TableContainer>
                <Table size='small' aria-label="Boka tid">
                  <TableHead>
                    <TableRow>
                      <TableCell>Tid</TableCell>
                      <TableCell align='right'>Platser kvar</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {events[eventId]?.slots?.map((slot) => {
                      let nbrOfFree = slot.max - slot.count;
                      const date = events[eventId].id
                      nbrOfFree = nbrOfFree < 0 ? 0 : nbrOfFree;
                      return (
                        <TableRow
                          key={slot.time}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleViewUsers(storeId.current, date, slot.time)}
                        >
                          <TableCell compoent='th' scope='row'>{slot.time}</TableCell>
                          <TableCell align='right'>{nbrOfFree}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Paper>
        </div>
      }
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
    },
  },
  modal: {
    width: 600,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
  },
  ul: {
    marginBottom: 50,
    "& li": {
      marginBottom: 10,
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  input: {
    height: 'auto',
  },
}));